"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomationLibrary = void 0;
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./AutomationLibrary.css"));
var CreateOrEditAutomationModal_1 = require("Library/AutomationLibrary/CreateOrEditAutomationModal");
var AutomationsApiService_1 = require("./AutomationsApiService");
var Types_1 = require("@CommonFrontendBackend/Tokens/Types");
var AutomationsGrid_1 = require("./AutomationsGrid");
var inversify_react_1 = require("inversify-react");
var UseAutomationsMetadata_1 = require("Library/AutomationLibrary/hooks/UseAutomationsMetadata");
var AutomationCard_1 = require("./AutomationCard");
var LibraryPresetCard_1 = require("Library/LibraryPresetCard");
var AutomationPill_1 = require("./Components/AutomationPill");
var BetaTag_1 = require("Common/BetaTag/BetaTag");
var DeleteAutomationModal_1 = require("Library/AutomationLibrary/DeleteAutomationModal");
var InlineOnboarding_1 = __importDefault(require("InlineOnboarding/InlineOnboarding"));
var PromptTypes_1 = require("Prompt/PromptTypes");
var useIntegrationSetup_1 = __importDefault(require("./hooks/useIntegrationSetup"));
var useAutomationsTelemetry_1 = require("Library/AutomationLibrary/hooks/useAutomationsTelemetry");
var useAutomationAssignmentExplainer_1 = require("Library/AutomationLibrary/hooks/useAutomationAssignmentExplainer");
var AutomationActivityLog_1 = require("./AutomationActivityLog");
var AutomationUtils_1 = require("Library/AutomationLibrary/AutomationUtils");
var UseHistoryTypes_1 = require("DataStores/User/UseHistory/UseHistoryTypes");
var DEFAULT_INTEGRATION = Types_1.ProviderType.Hubspot;
var YOUR_LIBRARY_INDEX = 0;
var RECOMMENDED_INDEX = 1;
var ACTIVITY_LOG_INDEX = 2;
var AUTOMATION_LIMIT = 70;
var AUTOMATION_ENABLED_LIMIT = 50;
var MAXIMUM_AUTOMATIONS_MESSAGE = "Maximum automations reached. Please contact support.";
var MAXIMUM_ENABLED_AUTOMATIONS_MESSAGE = "Maximum automations enabled. Please contact support.";
var getTabName = function (index) {
    switch (index) {
        case YOUR_LIBRARY_INDEX:
            return "Your Library";
        case RECOMMENDED_INDEX:
            return "Recommended";
        case ACTIVITY_LOG_INDEX:
            return "Activity Log";
        default:
            return "";
    }
};
var AutomationLibrary = function () {
    var modalService = (0, inversify_react_1.useInjection)("modal");
    var notifyUser = (0, inversify_react_1.useInjection)("notifyUser");
    var newFeaturesIndicatorStore = (0, inversify_react_1.useInjection)("rootDataStore").userDataStore.useHistoryDataStore.newFeaturesIndicatorStore;
    var telemetry = (0, useAutomationsTelemetry_1.useAutomationsTelemetry)(DEFAULT_INTEGRATION);
    var _a = __read((0, react_1.useState)(YOUR_LIBRARY_INDEX), 2), selectedTabIndex = _a[0], setSelectedTabIndex = _a[1];
    var _b = __read((0, react_1.useState)(undefined), 2), createOrEdit = _b[0], setCreateOrEdit = _b[1];
    var automationsMetadata = (0, UseAutomationsMetadata_1.useAutomationsMetadata)();
    var recommendedAutomations = (0, AutomationsApiService_1.useRecommendedAutomations)().data;
    var _c = (0, AutomationsApiService_1.useAutomations)({
        integrationName: DEFAULT_INTEGRATION,
    }), data = _c.data, create = _c.create, update = _c.update, enable = _c.enable, remove = _c.remove, isLoading = _c.isLoading;
    var isIntegrationSetup = (0, useIntegrationSetup_1.default)();
    var assignmentExplainer = (0, useAutomationAssignmentExplainer_1.useAutomationAssignmentExplainer)();
    var reachedCreationLimit = data === undefined ? false : data.length >= AUTOMATION_LIMIT;
    var reachedEnableLimit = data === undefined ? false : data.filter(function (automation) { return automation.enabled; }).length >= AUTOMATION_ENABLED_LIMIT;
    var createAutomation = function (automation) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, create(automation)];
                case 1:
                    _a.sent();
                    if (selectedTabIndex !== YOUR_LIBRARY_INDEX) {
                        setSelectedTabIndex(YOUR_LIBRARY_INDEX);
                    }
                    if ((createOrEdit === null || createOrEdit === void 0 ? void 0 : createOrEdit.action) === "createFromRecommended") {
                        telemetry.trackAutomationCreateClicked({
                            recommended: true,
                            description: automation.description,
                        });
                    }
                    else {
                        telemetry.trackAutomationCreateClicked({ recommended: false });
                    }
                    assignmentExplainer.potentiallyShowModal();
                    return [2];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (!isLoading) {
            telemetry.trackLibraryViewed(getTabName(selectedTabIndex));
        }
    }, [isLoading, telemetry, selectedTabIndex]);
    (0, react_1.useEffect)(function () {
        if (!isLoading && data && data.length === 0) {
            setSelectedTabIndex(RECOMMENDED_INDEX);
        }
    }, [isLoading]);
    (0, react_1.useEffect)(function () {
        newFeaturesIndicatorStore.hideNewFeatureIndicator(UseHistoryTypes_1.NewFeatureIndicatorName.AutomationsLibrary);
    }, []);
    var showDeleteAutomationModal = function (automation) { return __awaiter(void 0, void 0, Promise, function () {
        var confirmed;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, modalService.showDeleteModal({
                        explainer: react_1.default.createElement(DeleteAutomationModal_1.DeleteAutomationModalBody, { automation: automation }),
                        isEscapable: true,
                    })];
                case 1:
                    confirmed = _a.sent();
                    if (confirmed) {
                        try {
                            remove(automation.id);
                            notifyUser.success("Automation successfully deleted!");
                        }
                        catch (e) {
                            notifyUser.error("Automation cannot be deleted. Try again later.");
                        }
                    }
                    return [2];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: styles.wrapper },
        createOrEdit && automationsMetadata.data && (react_1.default.createElement(CreateOrEditAutomationModal_1.CreateOrEditAutomationModal, { createCallback: createAutomation, updateCallback: update, automation: createOrEdit.action === "edit"
                ? createOrEdit.automation
                : createOrEdit.action === "createFromRecommended"
                    ? createOrEdit.recommendedAutomation
                    : undefined, automationsMetadata: automationsMetadata.data, notifyUser: notifyUser, closeModal: function () { return setCreateOrEdit(undefined); } })),
        react_1.default.createElement("div", { className: styles.content },
            react_1.default.createElement(kaleidoscope_1.Stack, { className: "space-stack-l", direction: "horizontal", align: "center", gap: "m" },
                react_1.default.createElement(kaleidoscope_1.Heading, { level: "2", strong: true }, "Automations"),
                react_1.default.createElement(kaleidoscope_1.Tooltip, { size: kaleidoscope_1.TooltipSize.Large, content: react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: "space-stack-m" },
                            react_1.default.createElement(kaleidoscope_1.Text, { theme: "dark", size: "m", strong: true }, "Beta feature")),
                        react_1.default.createElement(kaleidoscope_1.Text, { theme: "dark", size: "xs" }, "This feature is currently in beta and free until June 2024. Enjoy your early access!")), wrapTarget: true },
                    react_1.default.createElement(BetaTag_1.BetaTag, null))),
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "spaceBetween", paddingBottom: "xxl" },
                react_1.default.createElement(kaleidoscope_1.Text, null,
                    "Create and manage automations within Qwilr.",
                    " ",
                    react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/article/829-hubspot-automations" }, "How automations work.")),
                react_1.default.createElement(kaleidoscope_1.Tooltip, { content: reachedCreationLimit
                        ? MAXIMUM_AUTOMATIONS_MESSAGE
                        : reachedEnableLimit
                            ? MAXIMUM_ENABLED_AUTOMATIONS_MESSAGE
                            : "", show: reachedEnableLimit || reachedCreationLimit ? undefined : false, wrapTarget: true },
                    react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () { return setCreateOrEdit({ action: "createNew" }); }, disabled: !isIntegrationSetup || reachedEnableLimit || reachedCreationLimit }, "Create Automation"))),
            react_1.default.createElement(InlineOnboarding_1.default, { title: "Introducing automations", description: react_1.default.createElement(react_1.default.Fragment, null,
                    "Automate your workflows to increase sales process efficiency, get better results and integrate data from your favorite apps. ",
                    react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/article/829-hubspot-automations" }, "Learn More")), video: {
                    videoThumbnail: "Automation_image.png",
                    videoSrc: "https://stock-videos.qwilr.com/onboarding/welcome-automations-beta.mp4",
                }, promptId: PromptTypes_1.PromptId.AutomationsOverview, enabled: true }),
            react_1.default.createElement(kaleidoscope_1.Tabs, { selectedIndex: selectedTabIndex, onChange: setSelectedTabIndex },
                react_1.default.createElement(kaleidoscope_1.TabList, { className: styles.tabList, "aria-label": "Menu type" },
                    react_1.default.createElement(kaleidoscope_1.Tab, null, "Your library"),
                    react_1.default.createElement(kaleidoscope_1.Tab, null, "Recommended Automations"),
                    react_1.default.createElement(kaleidoscope_1.Tab, null, "Activity log")),
                react_1.default.createElement(kaleidoscope_1.TabPanels, { className: styles.tabPanels },
                    react_1.default.createElement(kaleidoscope_1.TabPanel, null, (data === null || data === void 0 ? void 0 : data.length) === 0 ? (react_1.default.createElement(kaleidoscope_1.EmptyState, { title: "Create your first automation", subtitle: 'Click "Create automation" or select from "Recommended automations" to get started.', isDashed: true })) : (react_1.default.createElement(AutomationsGrid_1.AutomationsGrid, { renderAutomation: function (automation) { return (react_1.default.createElement(AutomationCard_1.AutomationCard, { key: automation.id, automation: automation, options: [
                                {
                                    label: "Edit",
                                    callback: function () {
                                        telemetry.trackAutomationClicked(automation.id);
                                        setCreateOrEdit({ action: "edit", automation: automation });
                                    },
                                },
                                {
                                    label: "Delete",
                                    callback: function () {
                                        showDeleteAutomationModal(automation);
                                    },
                                    destructive: true,
                                },
                            ], onClick: function () {
                                telemetry.trackAutomationClicked(automation.id);
                                setCreateOrEdit({ action: "edit", automation: automation });
                            }, enableCallback: function (id, enabled) {
                                telemetry.trackAutomationEnabledToggled(id, enabled);
                                return enable(id, enabled);
                            }, disabled: !isIntegrationSetup, toggleDisabled: reachedEnableLimit && !automation.enabled, toggleDisabledReason: reachedEnableLimit && !automation.enabled ? MAXIMUM_ENABLED_AUTOMATIONS_MESSAGE : "", integrationDisplayName: automationsMetadata.data
                                ? (0, AutomationUtils_1.getAutomationIntegrationDisplayName)(automation.integration, automationsMetadata.data)
                                : "" })); }, automations: data }))),
                    react_1.default.createElement(kaleidoscope_1.TabPanel, null,
                        react_1.default.createElement(AutomationsGrid_1.AutomationsGrid, { renderAutomation: function (automation, index) { return (react_1.default.createElement(LibraryPresetCard_1.LibraryPresetCard, { key: index, heading: automation.description, description: "", disabled: !isIntegrationSetup || reachedEnableLimit || reachedCreationLimit, disabledReason: reachedCreationLimit
                                    ? MAXIMUM_AUTOMATIONS_MESSAGE
                                    : reachedEnableLimit
                                        ? MAXIMUM_ENABLED_AUTOMATIONS_MESSAGE
                                        : "", onClick: function () {
                                    telemetry.trackRecommendedAutomationClicked(automation.description);
                                    setCreateOrEdit({ action: "createFromRecommended", recommendedAutomation: automation });
                                }, footer: react_1.default.createElement(AutomationPill_1.AutomationPill, { integrationName: automation.integration, fixedPosition: true, integrationDisplayName: automationsMetadata.data
                                        ? (0, AutomationUtils_1.getAutomationIntegrationDisplayName)(automation.integration, automationsMetadata.data)
                                        : "" }), tooltipText: "Create automation" })); }, automations: recommendedAutomations })),
                    react_1.default.createElement(kaleidoscope_1.TabPanel, null,
                        react_1.default.createElement(AutomationActivityLog_1.AutomationActivityLog, null)))))));
};
exports.AutomationLibrary = AutomationLibrary;
